import {
  FormValidator,
  FormValidatorBase,
} from "@/app/dynamic-components/forms/form-validations/form-validator.base";
import {DynamicFormEntry} from "@/app/dynamic-components/forms/dynamic-form.model";

export default class DateNotBeforeFormValidator extends FormValidatorBase {
  constructor() {
    super("notBefore", "validations.notBefore");
  }

  isValid(formData: any, entry: DynamicFormEntry): boolean {
    if (formData === undefined || formData === null) return true;
    if(!entry?.root) return true;
    let params = this.params.map(value => entry.root?.resolvePlaceholders(value));
    params = params.map(value => entry.root?.resolveFieldValue(value));
    if(params.length <= 0) return false;
    if(params[0] === '$nan') return false;
    const otherDate = new Date(params[0]);
    const date = new Date(formData);
    if(isNaN(otherDate.getTime()) || isNaN(date.getTime())) return false;
    return otherDate.getTime() <= date.getTime();
  }

  constructImpl(params: any[]): FormValidator {
    const validator = new DateNotBeforeFormValidator();
    validator.params = params;
    return validator;
  }
}
